import { combineReducers } from 'redux';
import auth from './auth/reducer';
import me from './me/reducer';
import user from './user/reducer';
import config from './config/reducer';
import emotion from './emotion/reducer';
import uploader from './uploader/reducer';

const reducers = combineReducers({
  auth,
  me,
  user,
  config,
  emotion,
  uploader,
});

export type AppState = ReturnType<typeof reducers>;

export default reducers;
